import $ from 'jquery';
import _ from 'lodash';
import { TweenMax } from 'gsap';

import common from '../base/common';
import emitter from '../base/emitter';
import ImagesSlider from '../components/imagesSlider';
import scroller from '../components/scroller';
import '../../vendors/gsap/src/uncompressed/plugins/ScrollToPlugin';
import ScrollElements from '../components/scrollElements';
import Select from '../components/select';

import News from '../pages/news';

class Pagination{

    constructor(){

        this.$logo = $('#main-logo');
        this.$loadBar = $('.LoadBar');
        this.$main = $('#main');
        this.imageSliders = [];
        this.page = $('[data-page]').data('page');
        this.pageObject = false;

        this.open           = this.open.bind(this);
        this.openNews       = this.openNews.bind(this);
        this.enter          = this.enter.bind(this);
        this.enterCallback  = this.enterCallback.bind(this);
        this.leave          = this.leave.bind(this);
        this.leaveCallback  = this.leaveCallback.bind(this);
        this.showSlider     = this.showSlider.bind(this);
        this.toTopCallback  = this.toTopCallback.bind(this);
        this.onPageLoad     = this.onPageLoad.bind(this);

        this.enterCallback(true);

        this.$loadBar.on('click', this.showSlider);
        emitter.on('paginator:open', this.open);
        new Select(document.getElementById('contacts-select'));

        $(window).on('load', this.onPageLoad);
        $(window).on('popstate', this.open);

    }

    enter(){

        this.$loadBar.addClass('__show');

        let tl = new TimelineMax({ onComplete: this.enterCallback});
        tl.add([
            TweenMax.to(this.$logo, 0.5, {x: 100}),
            TweenMax.to(this.$loadBar, 0.5, {height: common.screen.height, ease: Power4.easeInOut, delay: 0.2})
        ]);

    }

    enterCallback(firstLoad){

        this.page = $('[data-page]').data('page');

        if(this.page == 'news-listing' || this.page == 'news-detail'){

            $('[data-link]').on('click', this.openNews);
            // this.pageObject = new News(this.page == 'news-listing' ? false : true);

        }


        if(!firstLoad)
            common.$body.addClass('on-page');

        let imagesSliders = $('.ImagesSlider');
        if(imagesSliders.length){
            imagesSliders.each((index, item) => {
                this.imageSliders.push(new ImagesSlider($(item)));
            })
        }

    }

    leave(){

        this.$loadBar.removeClass('__show');
        scroller.disable();
        let tl = new TimelineMax({ onComplete: this.leaveCallback});
        tl.add([
            TweenMax.to(this.$loadBar, 0.5, {height: 0, ease: Power4.easeInOut}),
            TweenMax.to(this.$logo, 0.5, {x: 0, delay: 0.4})
        ]);

    }

    leaveCallback(){

        common.$body.removeClass('on-page');
        emitter.emit('sectionSlider:toggle');

    }

    open(href){

        let changeUrl = true;

        if(typeof href != 'string'){
            changeUrl = false;
            emitter.emit('sectionSlider:toggle');
            href = window.location.href;
        }

        this.$loadBar.addClass('__show');

        $.get(href, (html) => {

            let $html = $('<div />'),
                mainHtml;
            $html.append(html);
            mainHtml = $html.find('#main').html();
            this.$main.html(mainHtml);
            scroller.enable();

            if(changeUrl)
                history.pushState({}, $html.find('title').text(), href);

        },'html')

        setTimeout(this.enter, 1000);

    }

    showSlider(){

        if(common.$window.scrollTop() == 0)
            this.toTopCallback()
        else{
            TweenMax.to(window, 1, { scrollTo: { y: 0, autoKill:false }, ease: Power4.easeInOut, onComplete: this.toTopCallback})
        }

    }

    toTopCallback(){

        this.leave();

    }

    openNews(e){

        e.preventDefault();

        emitter.emit('loader:show');
        let $lastSlide = $('#SectionSlider .SectionSlider__Item').last();

        setTimeout(() => {

            TweenMax.to(window, 0.3, { scrollTo: { y: 0, autoKill:false }, ease: Power4.easeInOut, onComplete: () => {
                // scroller.disable();
            }});

            $.get(e.target.href, (html) => {

                let $html = $('<div />'),
                    mainHtml;
                $html.append(html);
                mainHtml = $html.find('#main').html();
                this.$main.html(mainHtml);

                let $newSlide = $html.find('.has-detail');

                $lastSlide.find('.SectionSlider__ItemBg').after($newSlide.find('.SectionSlider__ItemBg--detail'));
                TweenMax.set($lastSlide.find('.SectionSlider__ItemBg--detail'),{x: '-50%', y: '-50%'});
                $lastSlide.find('.TitleHero').text($newSlide.find('.TitleHero').text());


                emitter.emit('loader:load', mainHtml);
                history.pushState({}, $html.find('title').text(), e.target.href);
                scroller.enable();


            },'html')
        }, 500)

        // emitter.emit('loader:load', ['test']);

        // $.get(e.target.href)

        // scroller.disable();
        // TweenMax.to(window, 1, { scrollTo: { y: 0, autoKill:false }, ease: Power4.easeInOut, onComplete: this.toTopCallback})

    }

    onPageLoad(){

        new ScrollElements();

    }

}

export default new Pagination();


// WEBPACK FOOTER //
// ./js/components/pagination.js